var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stocktypes',{attrs:{"stocktypes":_vm.stockTypes},on:{"stockTypeChange":function($event){return _vm.getStockTypes()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }